import React from 'react';
import {
  Grid,
  ShimmerTypography,
  Space,
  MaxWidth,
  Cushion,
  ShimmerImage,
} from '@pitchero/react-ui';
import { range } from 'lodash';
import ProfileLoading from './profile-loading';

const ContactLoadingState = () => (
  <MaxWidth component="div" maxWidth={1366} center>
    <Cushion
      component="div"
      all="small"
      responsive={[{ minWidth: 'tab', props: { all: 'large' } }]}
    >
      <Grid
        columns="30% 1fr"
        responsive={[{ minWidth: 0, maxWidth: 894, props: { columns: '1fr' } }]}
      >
        <Space horizontal="medium">
          <ShimmerTypography preset="title" />
          <Space vertical="medium" component="div">
            <ShimmerTypography preset="body--small" />
            <ShimmerTypography preset="body--small" />
            <ShimmerTypography preset="body--small" />
            <ShimmerTypography preset="body--small" />
            <ShimmerTypography preset="body--small" />
            <ShimmerTypography preset="body--small" width="50%" />
          </Space>
          <ShimmerTypography preset="subtitle--medium" />
        </Space>
        <ShimmerImage width={600} height={200} />
      </Grid>
      <Grid columns="30%">
        <ShimmerTypography style={{ maxWidth: '40px' }} />
        <ShimmerTypography style={{ maxWidth: '250px', size: '24px' }} />
      </Grid>
      <Space vertical="large">
        <Grid preset="profiles">
          {range(12).map((index) => (
            <ProfileLoading key={index} />
          ))}
        </Grid>
      </Space>
    </Cushion>
  </MaxWidth>
);

export default ContactLoadingState;
